import React, { Fragment } from "react";
import { NumberInput } from "react-admin";

const SoccerTeamStats = ({ className, side }) => {
  const s = (key) => `${side}.soccer.${key}`;
  return (
    <Fragment>
      <NumberInput
        label="Total Goals"
        source={s("totalGoals")}
        className={className}
      />
      <NumberInput
        label="First Half Goals"
        source={s("firstHalfGoals")}
        className={className}
      />
      <NumberInput
        label="Second Half Goals"
        source={s("secondHalfGoals")}
        className={className}
      />
      <NumberInput
        label="Overtime Goals"
        source={s("overtimeGoals")}
        className={className}
      />
      <NumberInput
        label="Overtime 2 Goals"
        source={s("overtime2Goals")}
        className={className}
      />
      <NumberInput
        label="Shootouts"
        source={s("shootouts")}
        className={className}
      />
    </Fragment>
  );
};

export default SoccerTeamStats;
